import { Button, Flex, Link, Typography } from '@iheartjane/reefer';

interface MfaErrorProps {
  codeResent: boolean;
  onCancel?: () => void;
  resendCode: () => void;
  showCancelButton?: boolean;
  showResendButton: boolean;
}

export const MfaError = ({
  codeResent,
  onCancel,
  resendCode,
  showCancelButton,
  showResendButton,
}: MfaErrorProps) => {
  return (
    <Flex
      width="100%"
      height="100%"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Typography textAlign="center">Something went wrong.</Typography>
      <Typography textAlign="center" as="span">
        Please {!codeResent ? 'resend the code and' : ''} try again or{' '}
        <Link href="https://customer-support.iheartjane.com/s/contactsupport">
          contact support.
        </Link>
      </Typography>

      <Flex flexDirection="column">
        {showResendButton && (
          <Button label="Resend code" onClick={resendCode} mt={16} full />
        )}
        {showCancelButton && (
          <Button
            label="Cancel"
            onClick={onCancel}
            mt={16}
            variant="tertiary"
            full
          />
        )}
      </Flex>
    </Flex>
  );
};
